import axios from 'axios';
import { logout } from './auth';
import { store } from '../store';

/* eslint-disable no-plusplus */
const remapRecords = (data) => {
  const {
    recordBook,
    recordPageIdx,
  } = store.getState().records;
  const { AgentShopperCalls } = data;

  // empty list
  if (!recordBook.length || !recordBook[0].length) {
    for (let i = 0; i < data.TotalPages; i++) {
      recordBook.push([]);
    }
  }
  const pageToAddTo = recordPageIdx;
  AgentShopperCalls.forEach((record) => {
    recordBook[pageToAddTo].push(record);
  });
  store.dispatch({
    type: 'SET_RECORD_BOOK',
    payload: { recordBook, recordPageSize: data.PageSize, recordPageCount: data.TotalPages },
  });
};

// eslint-disable-next-line import/prefer-default-export
export const loadRecords = (params = {}) => {
  const { token } = store.getState().auth;
  return new Promise((resolve, reject) => {
    const { agencies: showAgencies } = store.getState().theme.features;
    const { records } = store.getState();

    let enrollStatus = null;
    if (records.stEnrollmentStatus === 'yes') {
      enrollStatus = 'True';
    } else if (records.stEnrollmentStatus === 'no') {
      enrollStatus = 'False';
    }
    const agentSentiment = records.stAgentSentiment === 'any' ? null : records.stAgentSentiment;
    const callerSentiment = records.stCallerSentiment === 'any' ? null : records.stCallerSentiment;
    const agency = records.stAgency === 'any' ? null : records.stAgency;
    let adherence = null;
    if (records.stAdherence === 'high') {
      adherence = '@.text_distance_average_weighted > .8';
    } else if (records.stAdherence === 'medium') {
      adherence = '@.text_distance_average_weighted <= .8 and @.text_distance_average_weighted >= .5';
    } else if (records.stAdherence === 'low') {
      adherence = '@.text_distance_average_weighted < .5';
    }

    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/telephony/agentcall/`,
      method: 'get',
      headers: { Authorization: `Token ${token}` },
      params: {
        sort: records.sortTerm || null,
        desc: records.sortInverse ? 'True' : 'False',
        trans_anal_filter: adherence ? `$..text_distance_average_weighted[${adherence}]` : null,
        lead_id: records.stLeadId || null,
        agent_npn: records.stAgentNPN || null,
        enrollment_date_start: records.stEnrollmentStartDate || null,
        enrollment_date_end: records.stEnrollmentEndDate || null,
        enrollment_status: enrollStatus,
        enrollment_id: records.stEnrollmentId || null,
        plan_type: records.stPlanType || null,
        plan_carrier: records.stPlanCarrier || null,
        agent_first_name: records.stAgentFirstName || null,
        agent_last_name: records.stAgentLastName || null,
        client_last_name: records.stClientLastName || null,
        client_first_name: records.stClientFirstName || null,
        phone_number: records.stClientPhone || null,
        call_start_start: records.stCallStartDate || null,
        call_start_end: records.stCallEndDate || null,
        agent_sentiment: agentSentiment,
        caller_sentiment: callerSentiment,
        agency_id: showAgencies ? agency : null,
        ...params,
      },
    }).then(({ data }) => {
      resolve(remapRecords(data));
    }).catch((err) => {
      if (err.response && err.response.status === 401) {
        store.dispatch({ type: 'SET_AUTH_EXPIRED' });
        logout();
      } else {
        store.dispatch({ type: 'SET_RECORDS_LOADING', payload: false });
        reject(err);
      }
    });
  });
};
